import React from 'react';
import styled from 'styled-components';
import LoadingBar from 'react-redux-loading-bar';

import tokens from '@storaensods/se-design-system/dist/_tokens.json';

const Wrapper = styled.div`
  width: 100vw;
  position: fixed;
  top: 0px;
  & > div > div {
    background-color: ${tokens.color.blue['100']} !important;
  }
`;

export default () => (
  <Wrapper>
    <LoadingBar />
  </Wrapper>
);
